<template>
  <div class="add-team-member-modal">
    <div class="modal-main-content">
      <button class="close-btn" @click="closeModal">x</button>
      <h2>Add Team Member</h2>
      <div v-if="internalUsers">
        <span>Select new team member:</span>
        <multiselect
          v-model="user"
          placeholder="Select name"
          autocomplete="off"
          class="co-custom-arrow account-details-multiselect"
          track-by="id"
          @select="onTeamMemberSelect"
          :clearOnSelect="true"
          :allow-empty="false"
          :options="filteredUsers"
          :custom-label="getUserName"
          :multiple="false"
          :deselect-label="''"
          :select-label="''">
           <span slot="noResult">No results found</span>
        </multiselect>
      </div>
      <div v-if="teamTitles">
        <span>Select title:</span>
        <multiselect
          v-model="title"
          placeholder="Type title or select"
          tag-placeholder="Press enter to add a title"
          autocomplete="off"
          class="co-custom-arrow account-details-multiselect"
          :clearOnSelect="true"
          :allow-empty="false"
          :options="teamTitles"
          :multiple="false"
          :taggable="true"
          :deselect-label="''"
          :select-label="''"
          @tag="onTeamTitle">
           <span slot="noResult">No results found</span>
        </multiselect>
      </div>
      <div class="buttons-container">
        <button class="cancel-btn" @click="closeModal">Cancel</button>
        <button @click="addTeamMember" :disabled="!validated" class="add-btn">Add</button>
      </div>
    </div>
  </div>
</template>

<script>
  import style from './AddTeamMemberModal.scss';
  import {ChevronDownIcon} from '../icons';
  import { mapGetters, mapActions } from "vuex";

  export default {

    data () {

      return {
        title: '',
        user: null,
      }
    },

    components: {
      ChevronDownIcon,
    },

    beforeMount () {
      this.getInternalUsers().then(users => {})
    },

    updated () {},

    created () {},

    computed: {
      ...mapGetters('AdminAccountDetailsTeamStore', [
        'sortedTeams',
        'teamTitles',
        'internalUsers',
        'resources',
      ]),

      ...mapGetters('AdminAccountDetailsStore', [
        'users',
        'accountId',
      ]),

      validated () {
        return this.title && this.user && this.user.id ? true : false;
      },

      //remove resources that already have titles
      filteredResources () {
        const currentTeamMembers = this.sortedTeams.map(team => team.user);

        return this.resources.filter(resource => {
          return !currentTeamMembers.includes(resource.id)
        })
      },

      //remove users that already have titles
      //and users that don't have portal enabled
      filteredUsers () {
        const currentTeamMembers = this.sortedTeams.map(team => team.user);
        
        return this.internalUsers.filter(user => {
          return !currentTeamMembers.includes(user.id)
        })
      }
    },

    methods: {

      ...mapActions('AdminAccountDetailsTeamStore', [
        'addTeamMemberTitle',
        'getInternalUsers',
        'getResources'
      ]),

      addTeamMember () {
        const { title, user, accountId } = this;

        const params = {
          user_id: user.id,
          title,
          accountId
        }

        this.addTeamMemberTitle(params)
          .then(result => {
            this.closeModal();
          })
          .catch(error => {
            console.error('create title error', error);
          });
      },

      onTeamMemberSelect (user) {
        // console.log('selected', user)
        // console.log('data', this.user)
      },

      onTeamTitle (title) {
        this.title = title;
      },

      getUserName ({firstname, lastname}) {
        return firstname + ' ' + lastname; 
      },

      closeModal() {
        // Logic to close the modal
        this.$emit('close');
      },
    }
  };
</script>